import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";

export class TermsCondition extends Component {
  componentDidMount() {
    document.title = "FOS - Terms & Conditions";
  }
  render() {
    return (
      <div>
        {" "}
        <h1 className="heading">Terms & Conditions</h1>
        <h3 className="heading3">FOS Mobile Application</h3>
        <Paper className="paper" elevation={3}>
          <ol className="ol">
            <li>
              <b>SCOPE:</b>
              <ol>
                <li>
                  FOS mobile application (“Application”) provided by Jio
                  Platforms Limited and/or its affiliates (“Company”, “we,” “us”
                  and “our”) located at 101, Saffron Near Centre Point,
                  Panchwati 5 Rasta, Ambavadi Ahmedabad GJ 380006 IN and made
                  available on devices powered by Android OS.
                </li>
                <li>
                  The Application helps employees of third party distributors
                  associated with Reliance Retail Limited (RRL) and their
                  respective employees or representatives to support
                  distribution network of RRL by providing services relating to
                  (a) sales and distribution including e-wallet sales; (b) track
                  on sales collection information for respective distributor
                  and/or (c) any other services as may be deemed necessary by
                  the Company.
                </li>
                <li>
                  Your (“you”, “your” or “user”) use of the Application is
                  subject to these Terms and Conditions (“Terms”) and the terms
                  of your employment with your respective enterprise.
                </li>
                <li>
                  By clicking the “I Agree” button, you acknowledge that you
                  have read, understood and accepted these Terms.
                </li>
                <li>
                  These Terms should be read in consonance with your enterprise
                  employment terms and conditions.
                </li>
                <li>
                  If you do not agree to be bound by the Terms please do not
                  access the Application or avail any Services provided through
                  the Application.
                </li>
                <li>
                  The Terms are an electronic record in terms of the Information
                  Technology Act, 2000 (as amended / re-enacted) (“IT Act") and
                  rules thereunder, and is published in accordance with the
                  provisions of Rule 3 (1) of the of the Information Technology
                  (Intermediaries Guidelines) Rules, 2011, which mandates for
                  publishing of rules and regulations, privacy policy and terms
                  of use for access or usage of Application. This electronic
                  record is generated by a computer system and does not require
                  any physical or digital signatures.
                </li>
              </ol>
            </li>
            <li>
              <b>MODIFICATIONS:</b>
              <ol>
                <li>
                  <u>Modifications of the Terms</u>: The Company reserves the
                  right to change the Terms under which the Services are
                  offered, including but not limited to the charges, if any,
                  associated with the use of the Services. The Terms may be
                  further modified based on changes in the business, legal and
                  regulatory requirements and will be updated online. We will
                  make all efforts to communicate any significant changes to
                  these Terms to you. You are encouraged to periodically visit
                  this page to review these Terms and any changes to it.
                </li>
                <li>
                  <u>Modification of Services</u>: The Company reserves the
                  right to add, modify or delete any content or features
                  available in the Services at any time at its sole discretion.
                </li>
              </ol>
            </li>
            <li>
              <b>USE LIMITATION:</b>
              <ol>
                <li>
                  Services offered by the Application are intended solely for
                  use by partners and employees of the Company and/ or its
                  affiliates while providing support to customers or
                  subscribers. You may not distribute, transmit, display,
                  perform, reproduce, publish, license, create derivative works
                  from, transfer, or sell any information, software, products or
                  Services offered by the Application.
                </li>
              </ol>
            </li>
            <li>
              <b>ACCEPTABLE USE RESTRICTIONS:</b>
              <ol>
                <li>
                  You agree:
                  <ol>
                    <li>
                      Not to use the Application in any unlawful manner, for any
                      unlawful purpose, or in any manner inconsistent with these
                      Terms, or act fraudulently or maliciously, for example, by
                      hacking into or inserting malicious code, including
                      viruses, or harmful data, into the Application, any
                      Service or any operating system;
                    </li>
                    <li>
                      Not to use the Application in a way that could damage,
                      disable, overburden, impair or compromise our systems or
                      security or interfere with other users, or restrict or
                      inhibit any other users from using the Application
                      (including by hacking or defacing the Application);
                    </li>
                    <li>
                      Not to collect or harvest any information or data from any
                      Service or our systems or attempt to decipher any
                      transmissions to or from the servers running any Service,
                      including, without limitation, by using any robot, spider,
                      site search/retrieval or other manual or automatic device
                      to retrieve, index, “scrape,” “data mine” or in any way
                      gather the Application or document content or reproduce or
                      circumvent the navigational structure or presentation of
                      the Application without our prior written consent.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>LIABILITY DISCLAIMER:</b>
              <ol>
                <li>
                  THE COMPANY AND/OR ITS RESPECTIVE AFFILIATES MAKES NO
                  REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY,
                  AVAILABILITY, TIMELINESS AND ACCURACY OF THE INFORMATION,
                  SOFTWARE AND SERVICES FOR ANY PURPOSE. ALL SUCH INFORMATION,
                  SOFTWARE AND SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF
                  ANY KIND. THE COMPANY AND/OR ITS RESPECTIVE SUPPLIERS HEREBY
                  DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS
                  INFORMATION, SOFTWARE, AND SERVICES, INCLUDING ALL IMPLIED
                  WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A
                  PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
                </li>
                <li>
                  YOU SPECIFICALLY AGREE THAT THE COMPANY SHALL NOT BE
                  RESPONSIBLE FOR UNAUTHORISED ACCESS TO OR ALTERATION OF YOUR
                  TRANSMISSIONS OR DATA, ANY MATERIAL OR DATA SENT OR RECEIVED
                  OR NOT SENT OR RECEIVED, OR ANY TRANSACTIONS ENTERED INTO
                  THROUGH THE APPLICATION. YOU SPECIFICALLY AGREE THAT THE
                  COMPANY IS NOT RESPONSIBLE OR LIABLE FOR ANY THREATENING,
                  DEFAMATORY, OBSCENE, OFFENSIVE OR ILLEGAL SERVICES OR CONDUCT
                  OF ANY OTHER PARTY OR ANY INFRINGEMENT OF ANOTHER'S RIGHTS,
                  INCLUDING INTELLECTUAL PROPERTY RIGHTS. YOU SPECIFICALLY AGREE
                  THAT THE COMPANY IS NOT RESPONSIBLE FOR ANY SERVICES SENT
                  USING AND/OR INCLUDED IN THE APPLICATION BY ANY THIRD PARTY.
                </li>
                <li>
                  IN NO EVENT SHALL THE COMPANY AND/OR ITS AFFILIATES BE LIABLE
                  FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL,
                  CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER ARISING OUT OF
                  OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE OF THE
                  APPLICATION, WITH THE DELAY OR INABILITY TO USE THE
                  APPLICATION OR RELATED SERVICES OR OTHERWISE, EVEN IF THE
                  COMPANY OR ANY OF ITS SUPPLIERS HAS BEEN ADVISED OF THE
                  POSSIBILITY OF DAMAGES.
                </li>
              </ol>
            </li>
            <li>
              <b>USER NAMES AND PASSWORDS:</b>
              <ol>
                <li>
                  You may be required to login through in order to access the
                  services using the login process as may be determined by the
                  Company from time to time. You are responsible for maintaining
                  the confidentiality of any login details you use to access the
                  Application and you agree not to transfer such details or user
                  names or lend or otherwise transfer your use or access to the
                  Application to any third party. You agree to notify us of any
                  unauthorized use of your details or user names or any other
                  breach of security related to your account of which you become
                  aware. You are fully responsible for all use of the
                  Application and any Services that occur in connection with
                  your user name, except to the extent that any unauthorized use
                  is not caused by any breach of your obligations under these
                  Terms.
                </li>
              </ol>
            </li>
            <li>
              <b>INTELLECTUAL PROPERTY RIGHTS:</b>
              <ol>
                <li>
                  The Company or all the right holders in/of the Application, as
                  the case may be, own title, interest and rights, including all
                  related intellectual property rights, in/of the Application
                  and the user acknowledges that such ownership shall include
                  all intellectual property rights arising from any suggestions,
                  enhancement requests, recommendations or other information
                  provided by the user, whether in the course of use of the
                  Application or otherwise.
                </li>
              </ol>
            </li>
            <li>
              <b>AVAILABILITY:</b>
              <ol>
                <li>
                  You acknowledge that the Application is provided over the
                  internet and so the quality and availability of the
                  Application may be affected by factors outside the Company’s
                  reasonable control. Accordingly, we cannot accept any
                  responsibility for any connectivity issues that you may
                  experience when using the Application. In addition, you
                  acknowledge and agree that you (and not the Company) are
                  responsible for obtaining and maintaining all
                  telecommunications, broadband and hardware, equipment and
                  services needed to access and use the Application or any
                  Services, and for paying any data charges that may be charged
                  to you by your network provider in connection with your use of
                  the Application.
                </li>
              </ol>
            </li>
            <li>
              <b>TERMINATION/ACCESS RESTRICTION:</b>
              <ol>
                <li>
                  In case a user is found using unfair means to use the Services
                  provided in the Application, the Company reserves the right to
                  blacklist, disable and terminate that user from further using
                  the Application or its Services.{" "}
                </li>
                <li>
                  The Company reserves the right, at its sole discretion, to
                  terminate your access to any or all Services of the
                  Application and the related Services or any portion thereof at
                  any time, without notice.
                </li>
              </ol>
            </li>
            <li>
              <b>DISPUTE RESOLUTION:</b>
              <ol>
                <li>
                  All disputes shall be governed under the laws of India and are
                  subject to the jurisdiction of the Courts of Mumbai only.
                </li>
              </ol>
            </li>
            <li>
              <b>CONTACT DETAILS:</b>
              <div className="contact-details">
                {/* <p>Address: </p> */}
                <p>
                  Email:{" "}
                  <a href="mailto:care@jioprimepartner.com">
                    care@jioprimepartner.com
                  </a>
                </p>
                <p>
                  Contact No: <a href="tel:18008912345">1800 891 2345</a>
                </p>
              </div>
            </li>
          </ol>
        </Paper>
      </div>
    );
  }
}

export default TermsCondition;
